export const languages = [
	{ name: "English", code: "en" },
	{ name: "Español", code: "es" },
	{ name: "Português", code: "pt" },
	{ name: "Русский", code: "ru" },
	{ name: "Українська", code: "uk" },
]
